import Tool, { simpleToolButton } from './Tool';
import scaleFrameToFitIcon from '../assets/icons/scaleFrameToFit.svg';
import { svgToIcon } from '../utils/svg';
import { isFrame } from '../objects/guards';

class ToolFrameSize extends Tool {
  static toolName = 'Scale to fit';

  static action({ selection }) {
    isFrame(selection) && selection.sizeFrameToContents();
  }

  static buttonComponent() {
    return simpleToolButton(ToolFrameSize, svgToIcon(scaleFrameToFitIcon));
  }
}

export default ToolFrameSize;
